// Deep-merge de objetos planos. Arrays se REEMPLAZAN (no se concatenan ni mergean
// por índice): analítica que pega un `series:[...]` completo gana sobre el base.
// Es el escape hatch del builder: option base (auto) <- override (render_config.option).
function isPlainObject(v) {
  return v != null && typeof v === 'object' && !Array.isArray(v);
}

export function deepMerge(base, override) {
  if (!isPlainObject(base)) return override === undefined ? base : override;
  if (!isPlainObject(override)) return override === undefined ? base : override;
  const out = { ...base };
  for (const key of Object.keys(override)) {
    const b = base[key];
    const o = override[key];
    out[key] = isPlainObject(b) && isPlainObject(o) ? deepMerge(b, o) : o;
  }
  return out;
}

export default deepMerge;
